var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-tab',{attrs:{"list":[{title: _vm.lang ==='en'?'Company Profile':'公司介绍', link: '/about/profile'}, {title: _vm.lang === 'en'?'News':'新闻动态', link: '/about/news'}, {
      title: _vm.lang === 'en'?'Exhibition':'展会信息',
      link: '/about/information'
    }, {title: _vm.lang === 'en'?'Contact':'联系我们', link: '/about/contact'}],"active":_vm.lang === 'en'?'Exhibition':'展会信息'}}),_c('post-list',{attrs:{"type":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }